var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewConfig(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 50,
    viewBox: "0 0 38 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5124 8.99806L26.0133 9.01844L22.6213 0.416504H0.666016V50.4165H37.4801V15.2755L26.5124 8.99806Z",
    fill: "#F8F9FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4793 15.2755L26.5116 8.99806L26.0125 9.01844L22.6205 0.416504H19.0723V50.4165H37.4793V15.2755Z",
    fill: "#E9EDF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6211 15.2755L37.48 15.2754L22.6211 0.416504V15.2755Z",
    fill: "#E9EDF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.332 33.9286C16.5731 33.9286 14.3365 31.692 14.3365 28.9331C14.3365 26.1742 16.5731 23.9376 19.332 23.9376L21.3023 20.2161L19.332 14.9038H16.6167V18.7334C15.7036 18.9759 14.8402 19.3395 14.0419 19.8029L11.3319 17.0928L7.49177 20.9329L10.2015 23.6427C9.73796 24.4408 9.37539 25.3046 9.13287 26.2177H5.30273V31.6484H9.13287C9.37539 32.5615 9.73796 33.4253 10.2015 34.2235L7.49177 36.9332L11.3319 40.7733L14.0419 38.0632C14.8402 38.5266 15.7035 38.8903 16.6167 39.1327V42.9623H19.332L21.3534 37.1953L19.332 33.9286Z",
    fill: "url(#paint0_linear_328_2581)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3613 31.6485V26.2178H29.5317C29.2892 25.3045 28.9275 24.4397 28.4639 23.6414L31.1723 20.933L27.3322 17.0929L24.6238 19.8013C23.8255 19.3377 22.9608 18.976 22.0474 18.7335V14.9038H19.332V23.9376C22.0909 23.9376 24.3276 26.1742 24.3276 28.9331C24.3276 31.692 22.0909 33.9286 19.332 33.9286V42.9624H22.0474V39.1328C22.9608 38.8903 23.8255 38.5286 24.6238 38.065L27.3322 40.7734L31.1723 36.9333L28.4639 34.2249C28.9275 33.4266 29.2892 32.5618 29.5317 31.6485H33.3613Z",
    fill: "url(#paint1_linear_328_2581)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_328_2581",
    x1: 13.328,
    y1: 42.9623,
    x2: 13.328,
    y2: 14.9038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#177BF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DAD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_328_2581",
    x1: 26.3467,
    y1: 42.9624,
    x2: 26.3467,
    y2: 14.9038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#177BF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DAD9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewConfig);
export default __webpack_public_path__ + "static/media/view_config.1b5a1afee79d64dbb55adad8b5c6ea9e.svg";
export { ForwardRef as ReactComponent };